module.exports = __webpack_public_path__ + "img/markerFerryGreen.dce93480.svg";